export enum DownloadJobStatus {
  QUEUED = 'QUEUED',
  RUNNING = 'RUNNING',
  READY = 'READY',
  FAILED = 'FAILED',
  DELETING = 'DELETING',
}

export enum DownloadJobPhase {
  STARTING = 'STARTING',
  COUNTING_DB = 'COUNTING_DB',
  QUERYING_DB = 'QUERYING_DB',
  MAPPING_RECORDS = 'MAPPING_RECORDS',
  WRITING_PRICAT = 'WRITING_PRICAT',
  WRITING_WORKBOOK = 'WRITING_WORKBOOK',
  WRITING_ZIP = 'WRITING_ZIP',
  READY = 'READY',
  FAILED = 'FAILED',
}

export type DownloadEventType = 'job-created' | 'job-progress' | 'job-ready' | 'job-failed' | 'job-pruned';

export interface DownloadJobView {
  jobId: string;
  downloadType: string;
  functionName: string;
  displayName: string;
  status: DownloadJobStatus;
  phase: DownloadJobPhase;
  startedAt: string;
  finishedAt: string | null;
  filename: string | null;
  fileSizeBytes: number | null;
  downloadUrl: string | null;
  warning: string | null;
  errorMessage: string | null;
  processedRecords: number | null;
  totalRecords: number | null;
  statusMessage: string | null;
  // Completed-generation summary (present on READY jobs that produced statistics).
  totalRows?: number | null;
  writtenRows?: number | null;
  rejectedRows?: number | null;
  adjustmentCount?: number | null;
}

export interface DownloadGenerateResponse {
  started: boolean;
  job: DownloadJobView;
}

export interface DownloadListResponse {
  items: DownloadJobView[];
}

export interface DownloadEvent extends DownloadJobView {
  eventType: DownloadEventType;
}
